import { useState, useRef } from 'react';
import { H5, Body3 } from '../../themes/typography';

function Description({
    description = '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>'
}) {
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const contentRef = useRef(null);

    const handleExpandToggle = () => {
        setIsDescriptionExpanded(!isDescriptionExpanded);
    };

    return (
        <div className="event-preview-description-container">
            <div>
                <H5 fontWeight={700}>Description</H5>
            </div>

            <div className="event-preview-description">
                <div
                    className={`event-preview-description-content ${isDescriptionExpanded ? 'expanded' : ''}`}
                    ref={contentRef}
                    style={{
                        maxHeight: isDescriptionExpanded
                            ? `${contentRef.current?.scrollHeight}px`
                            : '90px'
                    }}
                >
                    <div
                        dangerouslySetInnerHTML={{ __html: description }}
                        style={{
                            color: 'var(--quaternary-color)',
                            fontFamily: 'var(--secondary-content-font-family)'
                        }}
                    ></div>
                    {!isDescriptionExpanded && <div className="fade-effect"></div>}
                </div>

                <div className="event-preview-read-more">
                    <Body3
                        onClick={handleExpandToggle}
                        style={{
                            textDecoration: 'underline',
                            cursor: 'pointer'
                        }}
                        aria-expanded={isDescriptionExpanded}
                        role="button"
                    >
                        {isDescriptionExpanded ? 'Collapse' : 'Read More'}
                    </Body3>
                </div>
            </div>
        </div>
    );
}

export default Description;
